import { ReactNode } from 'react';
import { EquiposVentas } from './EquiposVentas';
import { EquiposNocturnos } from './EquiposNocturnos';
import { EquiposPersonalizados } from './EquiposPersonalizados';
import { useGetEquiposVentasQuery } from '../../../../api/vendedorApi';

export function EquiposContainer() {

    // TODO: Hacer que esta funcion se llame desde EquiposContainer y que el mismo resultado sea usado por los demas componentes "Equipos"
    const { data: equipos } = useGetEquiposVentasQuery(undefined, { refetchOnMountOrArgChange: true });

    return (
        <div className="flex flex-col h-full w-full border-s2 border-green-800">
            <p className="font-semibold text-3xl">Creación de equipos</p>

            {/* Componente de los equipos */}
            <div className="flex-1 min-h-0 w-full grid grid-cols-1 sm:grid-cols-3 gap-x-3 ">
                    <EquiposVentas 
                        equipos={equipos?.equipos}/> 
                    <EquiposNocturnos
                        equipos={equipos?.equiposNocturnos}
                        equiposDisponibles={equipos?.equipos}/>
                    <EquiposPersonalizados
                        equipos={equipos?.equiposCustom}/>
            </div>

        </div>
    )
}

interface Props2 {
    title: string;
    children:ReactNode;
}

export function EquiposListContainer({ title, children }: Props2) {
    return (
        <div className="min-h-0 flex flex-col">
            <p className="text-center font-semibold text-xl mb-2">{title}</p>


            <div className="flex-1 min-h-0 flex flex-col border-2 border-slate-300 h-full rounded-lg shadow-sm p-2">

                {children}

            </div>
        </div>
    );
}
